/**
 * Decides which Firebase project config the client uses ('staging' | 'prod').
 *
 * Precedence:
 *   1. Explicit build-time override via VITE_FIREBASE_ENV. The prod cutover
 *      build MUST set VITE_FIREBASE_ENV=prod. Hostname sniffing alone cannot
 *      detect the cutover: mytrainforge.com serves gearbox-staging today, and
 *      after the DNS flip the exact same hostname will serve gearbox-prod, so
 *      a hostname-only check would keep pointing the live site's JS at the
 *      staging Firestore/Auth/Storage while hosting serves the prod site.
 *   2. Hostname fallback (legacy behavior, unchanged): any gearbox-prod host
 *      picks prod; everything else (localhost, gearbox-staging.web.app,
 *      mytrainforge.com today) picks staging.
 *
 * Pure function, extracted from src/firebase/config.js so it can be unit
 * tested without triggering Firebase initialization side effects.
 */
export function pickFirebaseEnv(explicitEnv, hostname) {
  if (explicitEnv === 'prod' || explicitEnv === 'staging') return explicitEnv;
  if (explicitEnv) {
    // A typo like VITE_FIREBASE_ENV=production should be loud, not silent.
    console.warn(`pickFirebaseEnv: ignoring invalid VITE_FIREBASE_ENV "${explicitEnv}" (expected "staging" or "prod")`);
  }
  const host = hostname || '';
  if (host.includes('gearbox-prod')) return 'prod';
  return 'staging';
}
